import { FormattedMessage } from 'react-intl'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import { Link } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'

function UpdatePlanButton({ toChangePlan, handleUpdatePlanClick = () => {} }) {
  return (
    <PrimaryButton color="secondary" variant="contained">
      <Link
        component={RouterLink}
        to={toChangePlan}
        className="text-white no-underline"
        onClick={handleUpdatePlanClick}
      >
        <FormattedMessage
          id={'createNotification.dialog.overdraftNotice.dialog.upgrade'}
        />
      </Link>
    </PrimaryButton>
  )
}

UpdatePlanButton.propTypes = {
  toChangePlan: PropTypes.string.isRequired,
  handleUpdatePlanClick: PropTypes.func,
}

export default UpdatePlanButton
